import { Footer } from '@everlywell/leaves';
import React, { Ref } from 'react';
import ewAnalytics from 'utils/analytics';
import { sendNotificationEvent } from 'utils/api/subscriptionsApi';
import { ANALYTICS } from 'utils/constants/analytics';
import { showFlash } from 'utils/domHelpers';

interface Props {
  showFDADisclaimer?: boolean;
  showAvailableForSelectConditionsDisclaimer?: boolean;
  showMedicareDisclaimer?: boolean;
}

const FooterContainer = React.forwardRef(
  (
    {
      showFDADisclaimer = false,
      showAvailableForSelectConditionsDisclaimer = false,
      showMedicareDisclaimer = false,
    }: Props,
    ref: Ref<HTMLDivElement>,
  ) => {
    const handleSubscribeSubmit = async (email: string) => {
      try {
        await sendNotificationEvent({
          event_type: 'emailCollectionModal',
          resource: {
            user_id: undefined,
            email,
            data_fields: {
              emailCollectionModal: email,
            },
          },
        });
        showFlash('alert-success', `Thanks for subscribing!`);
      } catch (error) {
        showFlash(
          'alert-error',
          `There was an issue with your subscription. Please try again.`,
        );
      }
    };

    const handleOnClickLink = (label: string) => {
      ewAnalytics.track({
        event: ANALYTICS.EVENTS.CLICKED_LINK,
        data: {
          sectionHeader: 'Footer',
          label,
        },
      });
    };

    return (
      <div ref={ref}>
        <Footer
          onSubscribeSubmit={handleSubscribeSubmit}
          showFDADisclaimer={showFDADisclaimer}
          onClickLink={handleOnClickLink}
          showAvailableForSelectConditionsDisclaimer={
            showAvailableForSelectConditionsDisclaimer
          }
          showMedicareDisclaimer={showMedicareDisclaimer}
        />
      </div>
    );
  },
);

export default FooterContainer;
